import React, { Fragment, FunctionComponent, ReactElement } from "react";

export type LocalizedComboBoxOptionsWrapperComponentProps = {
    /** Potomek obsahují jednotlivé options, které je možné získat v podobě render props */
    children: ReactElement;
};

/**
 * Pomocná komponenta, která předá potomka s vytvořenými options k dalšímu zpracování v podobě render props.
 * @param children potomek obsahují jednotlivé options
 */
export const LocalizedComboBoxOptionsWrapperComponent: FunctionComponent<LocalizedComboBoxOptionsWrapperComponentProps> = ({
    children,
}) => (
    <Fragment>
        { children }
    </Fragment>
);
